import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { IRoom, IRoomRequest } from "../library/models/room";
import { BaseService } from "./baseService";

/** Which room, and what it should now be. */
export interface UpdateRoomVariables {
    id: number;
    payload: IRoomRequest;
}

/**
 * The clinic's treatment rooms, administrator only on the API. Not paged: a clinic has no
 * more kinds of room than it has disciplines, since a discipline is in one room at most.
 */
export class RoomsService extends BaseService {
    getRooms(): UseQueryOptions<IRoom[], Error> {
        return this.createGetQuery<IRoom[]>('/rooms');
    }

    createRoomMutation(): UseMutationOptions<IRoom, Error, IRoomRequest> {
        return this.createMutation<IRoom, IRoomRequest>('/rooms');
    }

    /** Hand-written because the id is in the path, which createMutation cannot put there. */
    updateRoomMutation(): UseMutationOptions<IRoom, Error, UpdateRoomVariables> {
        return {
            mutationFn: ({ id, payload }: UpdateRoomVariables): Promise<IRoom> =>
                this.put<IRoom>(`/rooms/${id}`, payload),
        };
    }

    /** Hand-written for the same reason, and because createMutation's delete sends `?id=`. */
    deleteRoomMutation(): UseMutationOptions<void, Error, number> {
        return {
            mutationFn: (id: number): Promise<void> => this.delete<void>(`/rooms/${id}`),
        };
    }
}
